export default __webpack_public_path__ + "static/media/tickIcon.963a7ede.svg";